<template>
    <div id="display-entity-information-component">
        <div :class="wrapperClass">
            <slot name="title">
                <div :class="`d-flex items-start gap-1 text-nowrap ${title ? '' : 'mr-1'}`">
                    <v-icon v-if="icon">{{ icon }}</v-icon>
                    <template v-if="showTitle">{{ title }} :</template>
                </div>
            </slot>

            <span :class="[title ? 'text-skin-default' : 'text-skin-medium', 'font-semibold']">
                <slot name="data">
                    {{ data && data !== '' ? data : '-' }}
                </slot>
            </span>

            <v-tooltip v-if="!showTitle" :text="title" activator="parent" location="top" open-delay="200" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'DisplayEntityInformationComponent',
    props: {
        title: {
            type: String,
            required: false,
        },
        showTitle: {
            type: Boolean,
            required: false,
            default: true,
        },
        icon: {
            type: String,
            required: false,
        },
        data: {
            required: false,
        },
        wrapperClass: {
            type: String,
            required: false,
            default: 'd-flex align-start gap-1 font-color-medium w-fit',
        },
    },
}
</script>

<style scoped>
#display-entity-information-component {
    display: flex;
}
</style>
